import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../../../components/BaseComponent';
import { logout } from '../../../../../modules/Api/actions';
import { makeSelectLocale } from '../../../../LanguageProvider/selectors';
import { selectUI } from '../../../selectors';
import { selectIsLoggedIn, selectUserRights } from '../../../../../modules/Api/selectors';
import {
  Car,
  Company,
  Document,
  Settings,
  Stats,
  Task,
  Tools,
  Email,
  Hexon,
  User,
  FileLines,
} from '../../../../../components/Icon';
import { Permission } from '../../../../../components/Permission';
import {
  VEHICLE_CRUD,
  COMPANY_CRUD,
  USERS_CRUD,
  INVOICE_CRUD,
  TOOLS_CRUD,
  ORB_CRUD,
  EMAIL_HISTORY_PAGE,
  STATISTICS_PAGE,
  KANBAN_BOARD_READ,
  WORKFLOW_CRUD,
  TRANSPORT_ADMINISTRATION,
} from '../../../../../components/Permission/constants';
import env from '../../../../../env';
import { AppClientId } from '../../../../../modules/Shared/constants';
import cn from 'classnames';

import styles from './Navbar.module.css';

class LeftComp extends BaseComponent {
  tofn(url) {
    return event => {
      // Prevent default behavior if ctrlKey or metaKey is pressed
      if (event?.ctrlKey || event?.metaKey) {
        event.preventDefault();
        window.open(url, '_blank'); // Open in a new tab explicitly
      } else {
        this.to(url); // Handle regular navigation
      }

      // Close the menu if `onClose` is defined
      this.props.onClose?.();
    };
  }

  isActive(pageIndex) {
    return this.props.history.location.pathname.indexOf(`/${pageIndex}`) == 0;
  }

  render() {
    if (!this.props.isLoggedIn) return null;
    return (
      <div className={styles.ContainerStyles}>
        <div className={`p-2 pt-3 mb-4 ${styles.containerLogo}`}>
          <img className={styles.imageStyles} src="../../../../public/images/logoV.svg" />
        </div>

        <nav id="sidebarMenu" className="side-nav">
          <ul className={cn('nav flex-column d-grid gap-2', styles.listNavBar)}>
            <Permission permission={KANBAN_BOARD_READ}>
              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/boards')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('boards'),
                      })}
                    >
                      <Task />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('boards'),
                      })}
                    >
                      {this.lbl('leftBar.overview')}
                    </span>
                  </a>
                </div>
              </li>
            </Permission>

            <li className="nav-item">
              <div className="d-flex align-items-center">
                <a
                  onClick={this.tofn('/vehicles')}
                  href="#"
                  className="nav-link  link-light d-flex align-items-center"
                  aria-current="page"
                >
                  <div
                    className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                      [styles.active]: this.isActive('vehicles'),
                    })}
                  >
                    <Car />
                  </div>

                  <span
                    className={cn('mx-3', styles.navbarOverride, {
                      [styles.active]: this.isActive('vehicles'),
                    })}
                  >
                    {this.lbl('leftBar.vehicles')}
                  </span>
                </a>
              </div>
            </li>
            {env.clientId !== AppClientId.HILTERMANN && (
              <Permission permission={INVOICE_CRUD}>
                <li className="nav-item">
                  <div className="d-flex align-items-center">
                    <a
                      onClick={this.tofn('/invoices')}
                      href="#"
                      className="nav-link  link-light d-flex align-items-center"
                      aria-current="page"
                    >
                      <div
                        className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                          [styles.active]: this.isActive('invoices'),
                        })}
                      >
                        <Document />
                      </div>

                      <span
                        className={cn('mx-3', styles.navbarOverride, {
                          [styles.active]: this.isActive('invoices'),
                        })}
                      >
                        {this.lbl('leftBar.invoices')}
                      </span>
                    </a>
                  </div>
                </li>
              </Permission>
            )}
            <Permission permission={USERS_CRUD}>
              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/users')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('users'),
                      })}
                    >
                      <User />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('users'),
                      })}
                    >
                      {this.lbl('leftBar.users')}
                    </span>
                  </a>
                </div>
              </li>
            </Permission>

            <Permission permission={COMPANY_CRUD}>
              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/companies')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('companies'),
                      })}
                    >
                      <Company />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('companies'),
                      })}
                    >
                      {this.lbl('leftBar.businesses')}
                    </span>
                  </a>
                </div>
              </li>
            </Permission>
            {env.clientId !== AppClientId.HILTERMANN && (
              <>
                <Permission permission={STATISTICS_PAGE}>
                  <li className="nav-item">
                    <div className="d-flex align-items-center">
                      <a href="#" className="nav-link  link-light d-flex align-items-center" aria-current="page">
                        <div
                          className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                            [styles.active]: this.isActive('statistics'),
                          })}
                        >
                          <Stats />
                        </div>

                        <span
                          className={cn('mx-3', styles.navbarOverride, {
                            [styles.active]: this.isActive('statistics'),
                          })}
                        >
                          {this.lbl('leftBar.statistics')}
                        </span>
                      </a>
                    </div>
                  </li>
                </Permission>

                <Permission permission={TOOLS_CRUD}>
                  <li className="nav-item">
                    <div className="d-flex align-items-center">
                      <a
                        onClick={this.tofn('/tools')}
                        href="#"
                        className="nav-link  link-light d-flex align-items-center"
                        aria-current="page"
                      >
                        <div
                          className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                            [styles.active]: this.isActive('tools'),
                          })}
                        >
                          <Settings />
                        </div>

                        <span
                          className={cn('mx-3', styles.navbarOverride, {
                            [styles.active]: this.isActive('tools'),
                          })}
                        >
                          {this.lbl('leftBar.tools')}
                        </span>
                      </a>
                    </div>
                  </li>
                </Permission>

                <Permission permission={ORB_CRUD}>
                  <li className="nav-item">
                    <div className="d-flex align-items-center">
                      <a
                        onClick={this.tofn('/orb')}
                        href="#"
                        className="nav-link  link-light d-flex align-items-center"
                        aria-current="page"
                      >
                        <div
                          className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                            [styles.active]: this.isActive('orb'),
                          })}
                        >
                          <Tools />
                        </div>

                        <span
                          className={cn('mx-3', styles.navbarOverride, {
                            [styles.active]: this.isActive('orb'),
                          })}
                        >
                          {this.lbl('leftBar.ORB')}
                        </span>
                      </a>
                    </div>
                  </li>
                </Permission>

                <Permission permission={EMAIL_HISTORY_PAGE}>
                  <li className="nav-item">
                    <div className="d-flex align-items-center">
                      <a
                        onClick={this.tofn('/email_history')}
                        href="#"
                        className="nav-link  link-light d-flex align-items-center"
                        aria-current="page"
                      >
                        <div
                          className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                            [styles.active]: this.isActive('email_history'),
                          })}
                        >
                          <Email fill="white" size="32" />
                        </div>

                        <span
                          className={cn('mx-3', styles.navbarOverride, {
                            [styles.active]: this.isActive('email_history'),
                          })}
                        >
                          {this.lbl('leftBar.email_history')}
                        </span>
                      </a>
                    </div>
                  </li>
                </Permission>
              </>
            )}
            <Permission permission={WORKFLOW_CRUD}>
              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/hxn')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('hxn'),
                      })}
                    >
                      <Hexon fill="white" size="32" />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('hxn'),
                      })}
                    >
                      {this.lbl('leftBar.hexon')}
                    </span>
                  </a>
                </div>
              </li>
              {env.clientId !== AppClientId.HILTERMANN && (
                <>
                  <li className="nav-item">
                    <div className="d-flex align-items-center">
                      <a
                        onClick={this.tofn('/website-users')}
                        href="#"
                        className="nav-link  link-light d-flex align-items-center"
                        aria-current="page"
                      >
                        <div
                          className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                            [styles.active]: this.isActive('website-users'),
                          })}
                        >
                          <Hexon fill="white" size="32" />
                        </div>

                        <span
                          className={cn('mx-3', styles.navbarOverride, {
                            [styles.active]: this.isActive('website-users'),
                          })}
                        >
                          {this.lbl('leftBar.website_users')}
                        </span>
                      </a>
                    </div>
                  </li>
                </>
              )}
              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/products')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('products'),
                      })}
                    >
                      <Car />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('products'),
                      })}
                    >
                      {this.lbl('leftBar.products')}
                    </span>
                  </a>
                </div>
              </li>
              <Permission permission={TRANSPORT_ADMINISTRATION}>
              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/transport-orders')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('transport-orders'),
                      })}
                    >
                      <FileLines />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('transport-orders'),
                      })}
                    >
                      {this.lbl('leftBar.transport-orders')}
                    </span>
                  </a>
                </div>
              </li>

              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/transporters')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('transport-orders'),
                      })}
                    >
                      <FileLines />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('transporters'),
                      })}
                    >
                      {this.lbl('leftBar.transporters')}
                    </span>
                  </a>
                </div>
              </li>
              </Permission>
              <li className="nav-item">
                <div className="d-flex align-items-center">
                  <a
                    onClick={this.tofn('/workflows')}
                    href="#"
                    className="nav-link  link-light d-flex align-items-center"
                    aria-current="page"
                  >
                    <div
                      className={cn(`d-flex align-items-center justify-content-center ${styles.ContainerIcon}`, {
                        [styles.active]: this.isActive('workflows'),
                      })}
                    >
                      <FileLines />
                    </div>

                    <span
                      className={cn('mx-3', styles.navbarOverride, {
                        [styles.active]: this.isActive('workflows'),
                      })}
                    >
                      {this.lbl('leftBar.workflows')}
                    </span>
                  </a>
                </div>
              </li>
            </Permission>
          </ul>
        </nav>
      </div>
    );
  }
}
LeftComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    isLoggedIn: selectIsLoggedIn(),
    rights: selectUserRights(),
    UI: selectUI(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    logout() {
      dispatch(logout());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Left = compose(withConnect, withRouter)(LeftComp);
